import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: "'Poppins', 'Poppins Regular', 'Poppins Medium', sans-serif",
  },
  components: {
   
    
    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: "#f5f5f5",
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          backgroundColor: "#f5f5f5",
          color: "#424242",
          fontSize: "12px",
          fontWeight: "600",
          padding:"0px"
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9e9e9e !important", 
            borderWidth: "1px !important", 
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9e9e9e !important", 
            borderWidth: "1px !important",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#9e9e9e !important", 
            borderWidth: "1px !important", 
          },
          
          // "& legend": {
          //   display: "none", 
          // },
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          backgroundColor: "#ffffff", 
          color: "#000000", 
          borderRadius: "8px", 
          padding: 0, 
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#757575",
           fontSize: "13px",
          "&.Mui-focused": {
            color: "#616161", 
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          backgroundColor: "#ffffff",
          color: "#000000",
          fontSize: "14px",
          fontWeight: "00",
          padding: "2px 5px",
          "&.Mui-selected": {
            backgroundColor: "#bdbdbd",
            color: "#000000",
          },
          "&.Mui-selected:hover": {
            backgroundColor: "#9e9e9e",
            color: "#ffffff",
          },
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        underline: {
          "&:after": {
            borderBottom: "none !important", // Removes blue focus underline
          },
          "&:before": {
            borderBottom: "1px solid #ccc", // Default color
          },
          "&:hover:before": {
            borderBottom: "1px solid #999 !important", // Underline on hover
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.Mui-focused": {
            color: "#000", // Keeps label color black on focus
          },
        },
      },
    },
    
  },
});

export default theme;
